<template>
  <div>
    <Breadcrumb :options="breadcrumb" />

    <div class="main-box">
      <div class="pdf-box" @scroll="handleScroll">
        <!-- <el-progress class="progress" color="#53a7ff"
              :percentage="Math.floor((loadedRatio / totalPages) * 100)">
            </el-progress> -->
        <div class="pdf-scale-box">
          <!-- {{ loadedRatio }}/{{ totalPages }} -->
          <pdf
            v-for="i in totalPages"
            :key="i"
            :src="selectedUrl"
            :page="i"
            @page-loaded="loadedRatio++"
          ></pdf>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import pdf from "vue-pdf";

export default {
  components: { pdf },
  data() {
    return {
      breadcrumb: [
        { name: "车辆管理", path: `/vehicle/investDanger` },
        { name: "隐患排查", path: `/vehicle/investDanger` },
        { name: "文件预览" },
      ],
      selectedUrl: "/fleet/hazardweekly/pdf?mode=preview&id=",
      totalPages: 1,
      pageHeight: 0,
      tabIdx: 0,
      count: 1,
      step: 5,
      loadedRatio: 0,
      id: null,
    };
  },
  methods: {
    getPageHeight() {
      const page = document.querySelector(".pdf-box");
      // console.log(page.offsetHeight)
      this.pageHeight = page.offsetHeight;
    },
    handleScroll(event) {
      const sTop = event.target.scrollTop;
      // 处理滚动事件
      // console.log(sTop); // 输出滚动位置
      // console.log(this.menu[this.tabIdx])
      // 滚动到倒数第3页
      if (sTop >= this.pageHeight * (this.totalPages - 3)) {
        console.log("start");
        this.count++;
        // const num = this.count * this.step;
        // const o = this.menu[this.tabIdx];
        // if (o.totalPages >= num) {
        //   this.totalPages = num;
        // } else {
        //   this.totalPages = o.totalPages;
        // }
      }
    },

    getNumPages(o) {
      // console.log({ ...o })
      let loadingTask = pdf.createLoadingTask(o.url);
      // console.log(loadingTask)
      loadingTask.promise
        .then((pdf) => {
          // console.log(pdf)
          o.totalPages = pdf.numPages;
          console.log(o.totalPages);
          const num = this.count * this.step;
          if (o.totalPages >= num) {
            this.totalPages = num;
          } else {
            this.totalPages = o.totalPages;
          }
        })
        .catch((error) => {
          console.error("pdf加载失败", error);
        });
    },
    downLoad() {
      const a = document.createElement("a");
      a.href = this.selectedUrl;
      const name = this.selectedUrl.split("/")[2];
      a.download = name;
      a.click();
    },
  },
  created() {
    this.pdf = require("vue-pdf");
    console.log("获取的pdf", this.pdf);
  },
  mounted() {
    const { id, mode } = this.$route.query;
    this.id = id;
    if (mode == "month") {
      this.selectedUrl = this.IP + "/fleet/hazardmonthly/pdf?mode=preview&id=" + id;
    } else {
      this.selectedUrl = this.IP + this.selectedUrl + id;
    }
    // console.log(this.IP, this.id);
    console.log(this.selectedUrl);
    this.getNumPages({
      url: this.selectedUrl,
    });
    this.$nextTick(() => {
      this.getPageHeight();
    });
  },
};
</script>

<style lang="less" scoped>
.main-box {
  display: flex;
  height: calc(100vh - 150px);
  position: relative;

  > .btn {
    position: absolute;
    left: 27px;
    top: 200px;
    z-index: 99;
  }

  /deep/.el-tabs {
    .el-tabs__header {
      width: 238px;
      margin-right: 200px;

      .el-tabs__nav {
        .el-tabs__active-bar.is-left {
          right: auto;
          left: 0;
          width: 4px;
          height: 56px;
        }

        .el-tabs__item.is-left {
          text-align: center;
          background-color: #fff;
          height: 56px;
          line-height: 56px;
          border-top: 1px solid #f9f9f9;

          &:first-child {
            border: 0 none;
          }
        }
      }

      .el-tabs__nav-wrap.is-left::after {
        width: 0;
      }
    }

    .el-tabs__content {
      height: 100%;
      // overflow-x: auto;
      // overflow-y: hidden;
      // border: 1px solid #707070;
      background-color: #fff;
      flex: 1;

      &::-webkit-scrollbar {
        width: 10px;
        // height: 10px;
      }

      &::-webkit-scrollbar-thumb {
        background-color: #ddd;
        border-radius: 3px;
        cursor: pointer;
      }
    }
  }

  .left {
    width: 238px;
    height: 100%;
    text-align: center;

    /deep/.el-menu-item {
      text-align: center;

      &.is-active {
        position: relative;

        &::before {
          content: "";
          position: absolute;
          height: 100%;
          width: 4px;
          background: #2691ff;
          left: 0;
          top: 0;
        }
      }
    }

    .down_btn {
      margin-top: 25px;
    }
  }

  .right {
    flex: 1;
    display: flex;
    justify-content: center;
    height: calc(100vh - 150px);
  }

  .pdf-box {
    height: calc(100vh - 150px);
    overflow-x: hidden;
    overflow-y: auto;
    position: relative;
    // border: 1px solid #707070;
    // background-color: #fff;

    &::-webkit-scrollbar {
      width: 10px;
      // height: 10px;
    }

    &::-webkit-scrollbar-thumb {
      background-color: #ddd;
      border-radius: 3px;
      cursor: pointer;
    }

    .pdf-scale-box {
      width: 1140px;

      .progress {
        width: 100%;
        position: fixed;
        top: 0;
        z-index: 999;
      }
    }
  }
}
</style>
